import React, { FC } from 'react';

export const View: FC<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = (props) => {
  return <div {...props} />;
};

export default View;
